package com.sweetlime.bingeamigo.di

import com.sweetlime.bingeamigo.api.TmdbApi
import com.sweetlime.bingeamigo.presentation.features.auth.AuthViewModel
import com.sweetlime.bingeamigo.presentation.features.auth.EmailVerificationViewModel
import com.sweetlime.bingeamigo.presentation.features.home.HomeViewModel
import com.sweetlime.bingeamigo.presentation.features.library.LibraryViewModel
import com.sweetlime.bingeamigo.presentation.features.library.TvLibraryViewModel
import com.sweetlime.bingeamigo.presentation.features.profile.ProfileViewModel
import com.sweetlime.bingeamigo.presentation.features.search.SearchViewModel
import com.sweetlime.bingeamigo.presentation.features.search.TvShowSearchViewModel
import com.sweetlime.bingeamigo.presentation.features.search.UserSearchViewModel
import com.sweetlime.bingeamigo.presentation.features.moviedetail.MovieDetailViewModel
import com.sweetlime.bingeamigo.presentation.features.notifications.NotificationsViewModel
import com.sweetlime.bingeamigo.presentation.features.review.FriendReviewsViewModel
import com.sweetlime.bingeamigo.presentation.features.review.ReviewViewModel
import com.sweetlime.bingeamigo.presentation.features.xplog.XpLogViewModel
import com.sweetlime.bingeamigo.presentation.features.tvdetail.SeasonDetailViewModel
import com.sweetlime.bingeamigo.presentation.features.tvdetail.TvShowDetailViewModel
import com.sweetlime.bingeamigo.presentation.features.user.UserProfileViewModel
import com.sweetlime.bingeamigo.repository.ActivityRepository
import com.sweetlime.bingeamigo.repository.AppNotificationsRepository
import com.sweetlime.bingeamigo.repository.AuthRepository
import com.sweetlime.bingeamigo.repository.FirebaseActivityRepository
import com.sweetlime.bingeamigo.repository.FirebaseAuthRepository
import com.sweetlime.bingeamigo.repository.FirebaseUserRepository
import com.sweetlime.bingeamigo.repository.FirebaseNotificationRepository
import com.sweetlime.bingeamigo.repository.LibraryRepository
import com.sweetlime.bingeamigo.repository.NotificationRepository
import com.sweetlime.bingeamigo.repository.ReviewRepository
import com.sweetlime.bingeamigo.repository.TmdbRepository
import com.sweetlime.bingeamigo.repository.UserRepository
import com.sweetlime.bingeamigo.repository.impl.FirebaseAppNotificationsRepository
import com.sweetlime.bingeamigo.repository.impl.LibraryRepositoryImpl
import com.sweetlime.bingeamigo.repository.impl.ReviewRepositoryImpl
import com.sweetlime.bingeamigo.service.XpService
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.FirebaseFirestoreSettings
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.firestore.firestoreSettings
import dev.gitlive.firebase.firestore.persistentCacheSettings
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val appModule = module {

    // Api
    single { TmdbApi() }

    // Movie Repository
    single { TmdbRepository(get()) }

    // Firebase
    single {
        Firebase.firestore.apply {
            // persistentCacheSettings is not supported on the JS/web target (Firebase JS SDK 10.x
            // throws if settings are applied after the instance is already initialized).
            // On mobile this works normally; on web it falls back to the default memory cache.
            runCatching {
                settings = firestoreSettings {
                    cacheSettings = persistentCacheSettings {
                        sizeBytes = FirebaseFirestoreSettings.CACHE_SIZE_UNLIMITED
                    }
                }
            }
        }
    }
    single<AuthRepository> { FirebaseAuthRepository() }
    single { XpService() }
    single<UserRepository> { FirebaseUserRepository(get(), get(), get()) }
    single<ActivityRepository> { FirebaseActivityRepository(get()) }
    single<LibraryRepository> { LibraryRepositoryImpl(get(), get(), get(), get(), get()) }
    single<ReviewRepository> { ReviewRepositoryImpl(get()) }
    single<NotificationRepository> { FirebaseNotificationRepository(get()) }
    single<AppNotificationsRepository> { FirebaseAppNotificationsRepository(get()) }

    // ViewModels
    viewModel { AuthViewModel(get(), get()) }
    viewModel { EmailVerificationViewModel(get()) }
    viewModel { HomeViewModel(get(), get(), get(), get(), get()) }
    viewModel { NotificationsViewModel(get(), get()) }
    viewModel { SearchViewModel(get(), get()) }
    viewModel { TvShowSearchViewModel(get(), get()) }
    viewModel { MovieDetailViewModel(get()) }
    viewModel { TvShowDetailViewModel(get()) }
    viewModel { SeasonDetailViewModel(get()) }
    viewModel { UserSearchViewModel(get(), get()) }
    viewModel { ProfileViewModel(get(), get()) }
    viewModel { UserProfileViewModel(get(), get(), get()) }
    viewModel { LibraryViewModel(get(), get()) }
    viewModel { TvLibraryViewModel(get(), get()) }
    viewModel { ReviewViewModel(get(), get(), get(), get(), get(), get()) }
    viewModel { FriendReviewsViewModel(get(), get(), get()) }
    viewModel { XpLogViewModel(get(), get()) }
}
